import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import classnames from "classnames";
import TypographyWrapper from "./TypographyWrapper";
import "./typography.scss";
export const Typography = memo(({ className, weight = "thin", variant = "text", color = "primary", isUppercase = false, isDangerous = false, mobileVariant = "", children, component, }) => {
    const classNames = classnames(["typography", `typography--desktop--${variant}`, `typography--${weight}`, `typography--${color}`, className], {
        "typography--uppercase": isUppercase,
        [`typography--mobile--${mobileVariant}`]: !!mobileVariant,
    });
    return (_jsx(TypographyWrapper, { component: component, variant: variant, className: classNames, isDangerous: isDangerous, children: children }));
});
